window.__buildTag = process.env.BUILD_TAG || 'unknown';
window.__buildDate = process.env.BUILD_DATE || 'unknown';